/**
 * The painted sign on the floor at the apothecary's door (lifted from
 * lantern-water's `world.js` `createShop`, "The way home"), drawn without its
 * lettering (`art.ts` `signTexture`: text is DOM, ADR 0005). Origin: the
 * sign's centre on the floor (the prototype's (0, 4.5)). No params. The
 * portal back to the town is the scene's.
 */
import * as THREE from 'three';
import { signTexture } from '../art.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'exit_mat',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const material = ctx.kit.shared('exit-mat:sign', () => new THREE.MeshStandardMaterial({ map: ctx.kit.shared('exit-mat:sign-map', () => signTexture()) }));
    const sign = ctx.mesh(root, ctx.plane, material, 0, 0.08, 0, 2.1, 0.9, 1);
    sign.rotation.x = -Math.PI / 2;
    return { root };
  },
};
